/* src/app/job-signoff-shredder/partials/job-signoff-shredder-manager/job-signoff-shredder-manager.component.scss */
/*# sourceMappingURL=job-signoff-shredder-manager.component.css.map */
